const defaultTheme = require('tailwindcss/defaultTheme');
const shared = require('@fasstech/flexiget/dist/tailwind.config.js');
const plugin = require('tailwindcss/plugin');

const dimensions = {
  '5px': '5px',
  '10px': '10px',
  '15px': '15px',
  '18px': '18px',
  '20px': '20px',
  '25px': '25px',
  '30px': '30px',
  '32px': '32px',
  '35px': '35px',
  '38px': '38px',
  '40px': '40px',
  '45px': '45px',
  '50px': '50px',
  '55px': '55px',
  '90px': '90px',
  '100px': '100px',
  '120px': '120px',
  '125px': '125px',
  '150px': '150px',
  '200px': '200px',
  '210px': '210px',
  '250px': '250px',
  '300px': '300px',
  '330px': '330px',
  '350px': '350px',
  '360px': '360px',
  '400px': '400px',
  '430px': '430px',
  '450px': '450px',
  '520px': '520px',
  '582px': '582px',
  '600px': '600px',
  '750px': '750px',
  '800px': '800px',
  '910px': '910px',
  '1000px': '1000px'
};

const colors = {
  'flexi-lightblue': '#98CBE2',
  'flexi-logo': '#262959',
  'flexi-grey': '#878F8F',
  'flexi-red': '#F36572',
  'flexi-lime': '#8FDD69',
  'flexi-valid': '#2CB469',
  'flexi-warning': '#F09103',
  'flexi-warning-toaster': '#F9E9D1',
  'flexi-valid-toaster': '#D4F0E1',
  'flexi-placeholder': '#CECACA',
  'flexi-blue': '#40A9FF',
  'flexi-col-table': '#F2F2F2',
  'flexi-error-toaster': '#FFE7E2',
  'flexi-error': '#F44D29',
  'flexi-info-toaster': '#E0F6F5',
  'flexi-blue-bg': '#F3FAFD',
  'flexi-super-admin': '#E5EDFD',
  'flexi-super-admin-bg': '#6C96F1',
  'flexi-admin': '#7EA2F2',
  'flexi-admin-bg': '#E6EDFB',
  'flexi-offer-editor': '#27AA58',
  'flexi-offer-editor-bg': '#E6F3EB',
  'flexi-qa': '#FF8D74',
  'flexi-qa-bg': '#FFD7CE',
  'flexi-regular': '#9AA0A0',
  'flexi-regular-bg': '#DADADA',
  'flexi-history-page-bg': '#F1FAFE',
  'flexi-history-widget': '#1A9B8C',
  'flexi-history-widget-bg': '#E6F6F4',
  'flexi-history-widget-border': '#A8DED8',
  'flexi-history-section': '#7C3AED',
  'flexi-history-section-bg': '#EDE9FB',
  'flexi-history-section-border': '#C4B5F8',
  'flexi-history-document': '#2563EB',
  'flexi-history-document-bg': '#EFF6FF',
  'flexi-history-document-border': '#BFDBFE',
  'flexi-history-placement': '#FA8C16',
  'flexi-history-placement-bg': '#FEF3C7',
  'flexi-history-error': '#FF785A',
  'flexi-history-milestone': '#3398F6',
  'flexi-history-highlight': '#FFF185',
  'flexi-bg-day-timeline': '#F8FAFC'
};

module.exports = {
  content: [
    './app/**/*.{html,js}'
  ],
  safelist: [
    { pattern: /^(text|bg)-(flexi-super-admin|flexi-admin|flexi-offer-editor|flexi-regular|flexi-qa)(-bg)?$/ },
    { pattern: /^(text|bg|border)-(flexi-history-(widget|section|document|external|placement|error|milestone|highlight))(-bg|-border)?$/ },
    'bg-flexi-error-toaster'
  ],
  theme: {
    screens: {
      xs: '0px',
      largeDesktop: { min: '1520px' },
      mediumDesktop: { max: '1520px' },
      smallDesktop: { max: '1280px' },
      xsDesktop: { max: '1170px' },
      ...defaultTheme.screens
    },
    extend: {
      ...shared.theme.extend,
      textColor: { ...shared.theme.extend.colors, ...colors },
      backgroundColor: { ...shared.theme.extend.colors, ...colors },
      borderColor: { ...shared.theme.extend.colors, ...colors },
      width: {
        ...shared.theme.extend.width, ...dimensions, fit: 'fit-content'
      },
      minWidth: { ...shared.theme.extend.minWidth, ...dimensions },
      maxWidth: { ...shared.theme.extend.maxWidth, ...dimensions },
      height: { ...shared.theme.extend.height, ...dimensions },
      minHeight: { ...shared.theme.extend.minHeight, ...dimensions },
      maxHeight: { ...shared.theme.extend.maxHeight, ...dimensions },
      lineHeight: { ...shared.theme.extend.lineHeight, ...dimensions },
      padding: { ...shared.theme.extend.padding, ...dimensions },
      margin: { ...shared.theme.extend.margin, ...dimensions },
      inset: { ...shared.theme.extend.inset, ...dimensions },
      outline: {
        'black-solid': ['1px solid black', '0px'],
        'black-dotted': ['2px dotted black', '0px']
      },
      outlineColor: { ...shared.theme.extend.colors, ...colors }
    },
    cursor: {
      'not-allowed': 'not-allowed',
      grab: 'grab',
      default: 'default'
    }
  },
  plugins: [
    ...(shared.plugins || []),
    plugin(({ addUtilities }) => {
      addUtilities({
        '.scrollbar-none': {
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none',
          '&::-webkit-scrollbar': { display: 'none' }
        }
      });
    }),
    plugin(({ addBase }) => {
      const cssVariables = Object.keys(colors).reduce((vars, color) => {
        vars[`--${color}`] = colors[color];
        return vars;
      }, {});
      addBase({ ':root': cssVariables });
    })
  ]
};

module.exports.colors = colors;
